import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Panel from './Panel';
import ComprobantesColumnsOrderUpsert from '../../app/comprobantes/list/components/ComprobantesColumnsOrderUpsert';

import PageError404 from '../../shared/errors/PageError404';

class PanelConfiguraciones extends Component {
  render() {
    return (
      <Switch>
        <Route
          path="/cuenta/panel-configuraciones"
          component={Panel}
          exact
        />
        <Route
          path="/cuenta/panel-configuraciones/columnas-facturas"
          component={ComprobantesColumnsOrderUpsert}
          exact
        />
        <Route
          path="*"
          component={PageError404}
        />
      </Switch>
    );
  }
}

export default PanelConfiguraciones;
